export const uiScale = {
  pagePadding: "px-4 sm:px-5 md:px-6 lg:px-12",
  sectionGap: "gap-4 md:gap-6",
  cardBase:
    "rounded-2xl md:rounded-3xl bg-white border border-slate-100 shadow-sm " +
    "p-4 md:p-6",
  cardTight:
    "rounded-2xl md:rounded-3xl bg-white border border-slate-100 shadow-sm " +
    "p-3.5 md:p-6",
  titleLg:
    "text-xl leading-snug md:text-2xl md:leading-snug font-bold tracking-tight text-slate-900 font-display",
  titleMd:
    "text-lg leading-snug md:text-xl md:leading-snug font-bold text-slate-900 font-display",
  body:
    "text-sm leading-relaxed md:text-base md:leading-relaxed text-slate-600",
  label:
    "text-[11px] md:text-xs font-bold uppercase tracking-wider text-slate-400",
  button:
    "h-11 md:h-12 px-4 md:px-5 rounded-xl md:rounded-2xl text-sm font-bold " +
    "min-w-[44px] min-h-[44px]",
  modalPanel:
    "w-full max-w-[560px] md:max-w-[680px] bg-white rounded-t-3xl md:rounded-3xl " +
    "shadow-2xl border border-slate-100 overflow-hidden",
  modalBody:
    "px-4 sm:px-5 md:px-6 py-4 md:py-6",
  modalMaxHeight:
    "max-h-[78vh] md:max-h-[84vh]",
};
